import { useAppSelector } from '../store';
import { environment } from '../config/environment';
import { authService } from '../services/auth.service';

/**
 * Hook for checking user role-based permissions
 * Provides methods to verify if current user can perform specific actions
 * @returns {Object} User role and permission check methods
 */
export const useRolePermissions = () => {
  const globalUser = useAppSelector(state => state.global.user);

  // In dev mode, use mock user role from Redux
  const userRole = environment.devAuthOff ? globalUser?.role || 'Administrator' : authService.getUserRole();

  const canExport = ['Administrator', 'Manager', 'Marketer'].includes(userRole || '');

  const canCreate = ['Administrator', 'Manager'].includes(userRole || '');

  const canViewSales = ['Administrator', 'Manager'].includes(userRole || '');

  const canDelete = (): boolean => {
    return userRole === 'Administrator';
  };

  const canEdit = (): boolean => {
    return ['Administrator', 'Manager', 'Marketer'].includes(userRole || '');
  };

  const canUpload = (): boolean => {
    return ['Administrator', 'Manager', 'Marketer'].includes(userRole || '');
  };

  const canUploadOkko = ['Administrator', 'Manager'].includes(userRole || '');

  const canUploadCompetitors = ['Administrator', 'Manager', 'Marketer'].includes(userRole || '');

  const canUploadCompetitorsData = ['Administrator', 'Manager'].includes(userRole || '');

  const canProcessOkkoPrices = ['Administrator', 'Manager'].includes(userRole || '');

  const canEditBindings = ['Administrator', 'Manager', 'Marketer'].includes(userRole || '');

  const canEditAzkList = ['Administrator', 'Manager', 'Marketer'].includes(userRole || '');

  const canGenerateOrders = ['Administrator', 'Manager'].includes(userRole || '');

  const canManageUsers = (): boolean => {
    return userRole === 'Administrator';
  };

  const canAccessScheduler = (): boolean => {
    return ['Administrator', 'Manager'].includes(userRole || '');
  };

  const canAccessRegionalPricing = (): boolean => {
    return ['Administrator', 'Manager', 'Marketer', 'User'].includes(userRole || '');
  };

  return {
    userRole,
    canViewSales,
    canExport,
    canCreate,
    canUploadOkko,
    canUploadCompetitors,
    canUploadCompetitorsData,
    canProcessOkkoPrices,
    canEditBindings,
    canEditAzkList,
    canDelete,
    canEdit,
    canUpload,
    canGenerateOrders,
    canManageUsers,
    canAccessScheduler,
    canAccessRegionalPricing
  };
};
